export const visit = (vm, at) => {
at({ "ja": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "\u4FA1\u683C\u3092\u8868\u793A" } } } } });
};